import curPostStore from "@/stores/curPostStore";

export const buildHeadingHash = (anchorName = '') => {
    const normalized = String(anchorName || '').trim();
    if (!normalized) {
        return '';
    }
    return `#${encodeURIComponent(normalized)}`;
};

export const decodeHeadingHash = (hash = '') => {
    const normalized = String(hash || '').trim();
    if (!normalized) {
        return '';
    }
    const raw = normalized.startsWith('#') ? normalized.slice(1) : normalized;
    if (!raw) {
        return '';
    }
    try {
        return decodeURIComponent(raw);
    } catch (error) {
        return raw;
    }
};

export const scrollToHeadingAnchor = (anchorName = '', options = {}) => {
    if (typeof document === 'undefined') {
        return false;
    }
    const normalized = decodeHeadingHash(anchorName);
    if (!normalized) {
        return false;
    }
    const anchorElement = document.getElementById(normalized);
    if (!anchorElement) {
        return false;
    }
    anchorElement.scrollIntoView({
        behavior: options.behavior || 'smooth',
        block: options.block || 'start',
    });
    curPostStore.setCurTitle(anchorElement.getAttribute('data-name') || anchorElement.innerText || normalized);
    return true;
};

export const pushHeadingHash = (anchorName = '', {replace = false} = {}) => {
    if (typeof window === 'undefined') {
        return;
    }
    const hash = buildHeadingHash(anchorName);
    if (!hash) {
        return;
    }
    const nextUrl = `${window.location.pathname}${window.location.search}${hash}`;
    if (replace) {
        window.history.replaceState(window.history.state, '', nextUrl);
        return;
    }
    window.history.pushState(window.history.state, '', nextUrl);
};
